import { ReactNode } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Grid } from '@material-ui/core';
import ScaffoldAppScreen from './ScaffoldAppScreen';
import { ProblemDetails } from '../../api';
import { SubtitleText } from '../controls/helpers';
import { useAppSelector } from '../../store';

export enum ErrorType {
    Completed,
    CustomMessage,
    Expired,
    Unknown,
    UserApplicantMismatch,
    ClientAlreadyInKiwiSaver,
    InvitationAlreadySent
}

const ErrorTypeDetail: Record<ErrorType, { title: string, description?: ReactNode | string }> = {
    [ErrorType.Completed]: {
        title: 'Application completed',
        description: 'This application has been completed. If you wish to start a new application contact your adviser or use the New Investment option inside the NZ Funds Digital Wallet.'
    },
    [ErrorType.CustomMessage]: {
        title: 'Whoops...'
    },
    [ErrorType.Expired]: {
        title: 'Application expired',
        description: 'This application has expired. To continue your application re-enter your access code in the NZ Funds Digital Wallet or contact your adviser.'
    },
    [ErrorType.Unknown]: {
        title: 'Unknown error occurred',
        description: <>An unknown error occurred. Please call Client Services on <a href="tel:0508733337">0508 733 337</a> for assistance.</>
    },
    [ErrorType.UserApplicantMismatch]: {
        title: 'Whoops...',
        description: <>The provided email address and/or IRD number belongs to another customer. Please call Client Services on <a href="tel:0508733337">0508 733 337</a> if you think this is a mistake.</>
    },
    [ErrorType.ClientAlreadyInKiwiSaver]: {
        title: 'Whoops...',
        description: <>The provided email address and/or IRD number belongs to a customer that is already in the NZ Funds KiwiSaver scheme. Please call Client Services on <a href="tel:0508733337">0508 733 337</a> if you think this is a mistake.</>
    },
    [ErrorType.InvitationAlreadySent]: {
        title: 'Application invite already sent to client',
        description: `This invite has already been sent to the client. You can review your client's application progress from the Onboarding status dashboard.`
    }
};

const ErrorScreen = ({ errors, errorType, message }: { errors?: ProblemDetails, errorType?: ErrorType, message?: string }) => {
    const { user } = useAppSelector(state => state.oidc);
    const history = useHistory();
    
    if (errorType === undefined) {
        if (errors?.title?.toLocaleLowerCase().includes('expired')) errorType = ErrorType.Expired;
        else if (errors?.title?.toLocaleLowerCase().includes('completed')) errorType = ErrorType.Completed;
        else errorType = ErrorType.Unknown;
    }

    const errorText = { ...ErrorTypeDetail[errorType], description: message || ErrorTypeDetail[errorType].description };

    return <ScaffoldAppScreen
        initialValues={{}}
        onSubmit={() => {}}
        header={errorText.title}
        route="error"
        hideNext
        title={errorText.title}>
        <SubtitleText>{errorText.description}</SubtitleText>
        <br />
        <br />
        {(errorType === ErrorType.UserApplicantMismatch || (errorType === ErrorType.CustomMessage && !!user)) &&
            <Grid container spacing={3} style={{ marginTop: 24 }}>
                <Grid item sm={9} xs={8}>&nbsp;</Grid>
                <Grid item sm={3} xs={4}>
                    <Button variant="contained" color="primary" fullWidth onClick={(_) => history.push('/client/authentication/signout')}>Log out</Button>
                </Grid>
            </Grid>
        }
    </ScaffoldAppScreen>
}

export default ErrorScreen;
